import { useState, useEffect } from 'react'
import { Modal, Button, Spinner, Alert, Form } from 'react-bootstrap'
import client from '../api/client'

function AuthCodeModal({ show, onHide, account, apiBasePath, onSuccess }) {
  const [step, setStep] = useState('idle')
  const [authorizeUrl, setAuthorizeUrl] = useState('')
  const [state, setState] = useState('')
  const [authCode, setAuthCode] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (show && account) {
      startFlow()
    }
  }, [show, account])

  const handleClose = () => {
    setStep('idle')
    setAuthorizeUrl('')
    setState('')
    setAuthCode('')
    setError('')
    onHide()
  }

  const startFlow = async () => {
    setStep('starting')
    setError('')
    setAuthorizeUrl('')
    setState('')
    setAuthCode('')

    try {
      const resp = await client.post(`${apiBasePath}/${account.id}/auth/start`)
      setAuthorizeUrl(resp.data.authorize_url)
      setState(resp.data.state)
      setStep('waiting_code')
      window.open(resp.data.authorize_url, '_blank')
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors du démarrage de l\'authentification')
      setStep('error')
    }
  }

  const handleExchange = async (e) => {
    e.preventDefault()
    setStep('exchanging')
    setError('')

    try {
      await client.post(`${apiBasePath}/${account.id}/auth/exchange`, {
        code: authCode.trim(),
        state: state
      })
      setStep('success')
      onSuccess(account)
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors de l\'échange du code d\'autorisation')
      setStep('error')
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Authentification OAuth - Claude</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {step === 'starting' && (
          <div className="text-center py-4">
            <Spinner animation="border" className="mb-3" />
            <p>Démarrage du flux d'authentification...</p>
          </div>
        )}

        {step === 'waiting_code' && (
          <div className="py-3">
            <p className="mb-3">
              1. Une nouvelle fenêtre s'est ouverte avec la page d'autorisation Claude.
              <br />
              2. Connectez-vous à votre compte Claude et autorisez l'application.
              <br />
              3. Après autorisation, copiez le code d'autorisation affiché.
              <br />
              4. Collez le code ci-dessous et validez.
            </p>

            <div className="mb-3">
              <a
                href={authorizeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-primary btn-sm"
              >
                Ouvrir la page d'autorisation à nouveau
              </a>
            </div>

            <Form onSubmit={handleExchange}>
              <Form.Group className="mb-3">
                <Form.Label>Code d'autorisation *</Form.Label>
                <Form.Control
                  type="text"
                  value={authCode}
                  onChange={(e) => setAuthCode(e.target.value)}
                  placeholder="Collez le code ici..."
                  required
                  autoFocus
                />
                <Form.Text className="text-muted">
                  Le code commence généralement par "sk-ant-oac01-"
                </Form.Text>
              </Form.Group>

              <div className="d-flex justify-content-end gap-2">
                <Button variant="secondary" onClick={handleClose}>
                  Annuler
                </Button>
                <Button variant="primary" type="submit" disabled={!authCode.trim()}>
                  Valider
                </Button>
              </div>
            </Form>
          </div>
        )}

        {step === 'exchanging' && (
          <div className="text-center py-4">
            <Spinner animation="border" className="mb-3" />
            <p>Échange du code d'autorisation en cours...</p>
          </div>
        )}

        {step === 'success' && (
          <Alert variant="success" className="mb-0">
            Authentification réussie pour <strong>{account?.email}</strong>.
          </Alert>
        )}

        {step === 'error' && (
          <>
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleClose}>
                Fermer
              </Button>
              <Button variant="primary" onClick={startFlow}>
                Réessayer
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
      {step === 'success' && (
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Fermer
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default AuthCodeModal
